"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _s3upload = _interopRequireDefault(require("react-s3-uploader/s3upload"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var DEFAULT_OPTIONS = {
  preprocess: function preprocess(file, next) {
    next(file);
  },
  onSignedUrl: function onSignedUrl() {},
  onProgress: function onProgress() {},
  onFinish: function onFinish() {},
  onError: function onError() {},
  signingUrl: '/core/api/s3/sign',
  scrubFilename: function scrubFilename(filename) {
    return ".".concat(filename.split('.').pop());
  },
  s3path: '',
  autoUpload: true
};
/**
 * Creates a new S3Uploader.
 * @class
 */

var S3Uploader = /*#__PURE__*/function () {
  /**
   * @constructs S3Uploader
   * @param {Object} options S3Uploader options
   * @param {string} options.server S3Uploader server
   * @param {string} options.signingUrl S3Uploader singingUrl
   * @param {string} options.server S3Uploader server
   * @param {Array} options.successResponses {code, code} Success responses
   * @param {string} [options.signingUrlMethod="GET"] S3Uploader singingUrlMethod
   * @param {string} [options.s3path=""] S3Uploader s3path
   * @param {boolean} [options.autoUpload=true] S3Uploader autoupload
   * @param {Object} options.files S3Uploader files
   * @param {Object} options.fileElement S3Uploader fileElement
   * @param {Function} options.onFinishS3Put S3Uploader onFinishS3Put function
   * @param {Function} options.onFinish OnFinish uploading function
   * @param {Function} options.preprocess preprocess function
   * @param {Function} options.onProgress onProgress uploading function
   * @param {Function} options.onError on upload error function
   * @param {Function} options.onSignedUrl signed url function
   * @param {Function} options.fileElement fileElement
   * @param {Function} options.inputRef inputRef
   * @param {Function} options.contentDisposition
   * @param {Object} options.uploadRequestHeaders
   * @param {boolean} options.getSignedUrl
   */
  function S3Uploader(options) {
    _classCallCheck(this, S3Uploader);

    this.options = void 0;
    this.myUploader = void 0;
    this.options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }
  /**
   * Upload the file
   */


  _createClass(S3Uploader, [{
    key: "uploadFile",
    value: function uploadFile() {
      this.myUploader = new _s3upload["default"](_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), this.options));
    }
    /**
     * Abort the upload
     */

  }, {
    key: "abort",
    value: function abort() {
      if (this.myUploader) {
        this.myUploader.abortUpload();
      }
    }
  }]);

  return S3Uploader;
}();

exports["default"] = S3Uploader;
module.exports = exports["default"];